{
  "Mon": "Monday",
  "Tue": "Tuesday",
  "Wed": "Wednesday",
  "Thu": "Thursday",
  "Fri": "Friday",
  "Sat": "Saturday",
  "Sun": "Sunday",
  "CORE": {
    "notificationDateFormat": "d/M/yyyy",
    "update": "Loading...",
    "youAreOffline": "Device offline! Connect to a network and try again later!",
    "comeBack": "{{icon}} your skis are waiting for you",
    "help": "Help",
    "notification": {
      "ok": "Got it"
    },
    "skiHire": "Ski Rental"
  },
  "ALPINSKIHIRE": {
    "AR": {
      "start": {
        "selectBookingParametersFact3": "Pay in your own currency! Alpy.com will carry the cost of exchanging your currency. Rates are updated every day.",
        "searchHeadline": "Where would you like to rent your skis or snowboard?"
      },
      "showTownReserveEarlyEnoughInfo": "Please note that there might be a lack of equipment in the stores during the season. We recommend you book in advance.",
      "shop_filter_distance_to_center": "<strong>Distance</strong> from city centre: <strong><span id='range'>{{ distance }}</span>km</strong>",
      "shopSearch": {
        "formSearchButtonLabel": "SEARCH",
        "promocode": {
          "couponCodeIsInCart": "The coupon code {{ code }} has been added to your cart and will be included on the checkout page.",
          "typePromo": "PROMO",
          "typeCoupon": "COUPON"
        }
      }
    },
    "SB": {
      "start": {
        "selectBookingParametersFact3": "Pay in your own currency! SNOWBRAINER.com will carry the cost of exchanging your currency. Rates are updated every day.",
        "searchHeadline": "Where would you like to hire your ski equipment?",
        "teaserPanel": {
          "headlineShops": "Our Shops",
          "textShops": "Snowbrainer offers you more than 600 ski hire shops all over Europe. Rent your skis online in France, Austria, Switzerland, Germany, Italy, Czech Republic, Bulgaria and Andorra. High quality equipment and friendliness are our biggest aims.",
          "headlineInsurance": "Our additional offers",
          "textInsurance": "Snowbrainer offers different guarantees for a safe and enjoyable ski holiday. You can protect your equipment against breakage, damage and theft. Moreover we offer full insurance coverage for the transport to the next hospital in case of a ski accident - to give you and your family complete peace of mind. As always at unbeatable conditions!",
          "headlineCommitment": "Our commitment",
          "textCommitment": "Many try to copy our outstanding customer service! Since 2007 we have looked after 60.000+ clients. We treat every client as an individual. You can reach us via online chat, phone or e-mail – whatever you prefer."
        },
        "noFeeText": "<p><strong>\"Real SNOWBRAINER\"</strong> hate handling fees. :-)<br>No handling fees for bookings or exchange rate.<br><strong>Take full advantage!</strong><br><small>Take full advantage, only until</small></p><small>{{ untilDate }}</small>"
      },
      "showTownReserveEarlyEnoughInfo": "It's not rare that our shop partners lack of equipment during the season. That is why, it is always the best option to book online in advance.",
      "shopSearch": {
        "formSearchButtonLabel": "SEARCH",
        "promocode": {
          "couponCodeIsInCart": "The coupon code {{ code }} has been added to your cart and will be included on the checkout page.",
          "typePromo": "PROMO",
          "typeCoupon": "COUPON"
        }
      },
      "heroBenefits": {
        "headline": " The best online ski rental prices",
        "subheadline": "Up to <span>-{{discount}}%</span> discount*",
        "benefitsHeader": "Your benefits",
        "benefitFirst": "Now up to -{{discount}}% savings in comparison with prices applied in stores",
        "benefitSecond": "No further booking-fees",
        "benefitThird": "Flexible cancellation solutions",
        "benefitFourth": "Optional: pay in GBP"
      }
    },
    "SF": {
      "start": {
        "selectBookingParametersFact3": "More than 900 shops",
        "searchHeadline": "Where would you like to rent your skis or snowboard?"
      },
      "showTownReserveEarlyEnoughInfo": "Please note that there might be a lack of equipment in the stores during the winter season. We recommend you to book early enough.",
      "shopSearch": {
        "formSearchButtonLabel": "SEARCH",
        "promocode": {
          "couponCodeIsInCart": "The coupon code {{ code }} has been added to your cart and will be included on the checkout page.",
          "typePromo": "PROMO",
          "typeCoupon": "COUPON"
        }
      },
      "heroBenefits": {
        "headline": "The best online ski hire prices",
        "subheadline": "Up to <span>-{{discount}}%</span> off*",
        "benefitsHeader": "Benefits",
        "benefitFirst": "Best prices online: up to -{{discount}}% savings in comparison with prices applied in stores",
        "benefitSecond": "No booking or transaction fees",
        "benefitThird": "Flexible cancellations & changes",
        "benefitFourth": "Book online - pick up in the shop"
      }
    },
    "DU": {
      "start": {
        "selectBookingParametersFact3": "Pay in your own currency! skidiscount.co.uk will carry the cost of exchanging your currency. Rates are updated every day.",
        "searchHeadline": "In which place do you plan to hire your skis or snowboard?",
        "seoTextHeader": "High-quality skis for the best skiing experience",
        "seoText": "Skiing without the headache! Let Ski Discount take responsibility for your safety and enjoyment. Our trusted professionals work alongside established brands to offer you ski equipment that is not only perfectly maintained, but also tailored and prepared just for you.<br /><br />Three simple steps for getting your equipment and saving up to 60% with Ski Discount:<br /><br />1. Select your resort and choose a shop; pick from out store network of over 600 professional ski rental stores across 7 European countries. Then select the dates of your trip.<br />2. Select your equipment according to your ability and needs. Ski Discount offers a diverse range of skis and snowboard across 4 collections; men's and women's skis, mini skis, children's skis, and snowboards.<br />3. Pay online with our secure third party payment method, and receive your voucher immediately by email. Collect your equipment in store from 5pm the day before you begin skiing.<br />"
      },
      "showTownReserveEarlyEnoughInfo": "Often during the winter season, it happens that the stores lack of equipment. To avoid this issue, and secure your holidays, we strongly recommend you to hire your equipment online in advance.",
      "shopSearch": {
        "formSearchButtonLabel": "EXPLORE",
        "promocode": {
          "couponCodeIsInCart": "The coupon code {{ code }} has been added to your cart and will be included on the checkout page.",
          "typePromo": "PROMO",
          "typeCoupon": "COUPON"
        }
      },
      "heroBenefits": {
        "headline": "Get the best offer",
        "subheadline": "Up to <span>-{{discount}}%</span> savings*",
        "benefitsHeader": "Our offer",
        "benefitFirst": "Save up to -{{discount}}% savings in comparison with prices applied in stores",
        "benefitSecond": "No booking-fees",
        "benefitThird": "Easy cancellation & changes solutions",
        "benefitFourth": "More than 1.000 ski hire shops online"
      }
    },
    "BP": {
      "start": {
        "selectBookingParametersFact3": "Pay in your own currency! BEST-PRICE-SKI-RENTAL.com will carry the cost of exchanging your currency. Rates are updated every day.",
        "searchHeadline": "In which ski resort would you like to rent your ski equipment?",
        "seoTextHeader": "Best Price Ski Rental is the number 1 on ski hire at the best price",
        "seoText": "In 10 years, Best Price Ski Rental has become a major player in the online ski rental at discount prices.<br /><br />We are working with the largest network of ski shops. Besides, you benefit from 20% to 50% on your ski rental equipment in over 500 ski resorts in 7 countries in Europe : France, Italy, Andorra, Austria, Germany, Switzerland, Czech Republic.<br /><br />Book your skis with Best Price Ski Rental in 3 steps.<br /><br />1. Select your ski resort and your store. Enter your first day of ski rental and the duration of your stay.<br />2. Select your ski equipment according to your level and your wishes: adult skis (man and lady), snowboards, mini skis, junior skis, baby skis and teen skis.<br />3. Print your voucher and present it on your arrival in the resort to take your ski equipment."
      },
      "showTownReserveEarlyEnoughInfo": "The shops can easily lack of equipment during the winter. Therefore we highly recommend you to book in advance.",
      "shopSearch": {
        "formSearchButtonLabel": "NEXT STEP",
        "promocode": {
          "couponCodeIsInCart": "The coupon code {{ code }} has been added to your cart and will be included on the checkout page.",
          "typePromo": "PROMO",
          "typeCoupon": "COUPON"
        }
      },
      "heroBenefits": {
        "headline": "Secure the advantages of an online booking",
        "subheadline": "Up to <span>-{{discount}}%</span> savings*",
        "benefitsHeader": "Advantages",
        "benefitFirst": "Book online and save up to -{{discount}}% savings in comparison with prices applied in stores",
        "benefitSecond": "No transaction fees",
        "benefitThird": "Easy cancellation & changes solutions",
        "benefitFourth": "More than 1.000 ski hire shops online"
      }
    },
    "offer": {
      "title": "Why book with {{ platformname }}"
    },
    "start": {
      "advantagesHeadline": "Best prices guaranteed for ski hire by making an online booking",
      "listedBrands": "Available brands",
      "topTowns": "Top Ski Hire locations"
    },
    "sidebar": {
      "hotlineItalic": "Let us help you!",
      "callNow": "Call now on: ",
      "hotline": "Hotline"
    },
    "shopSearch": {
      "validation": {
        "selectAgeForEveryChild": "Please state the age of each child (the age at the beginning of the rental)",
        "onePersonRequired": "choose one person at least",
        "enterTown": "Please select a ski resort"
      },
      "minified": {
        "users": "{{ number_adults }} Adults, {{ number_children }} Children",
        "date": "{{ start_date }} - {{ end_date }}",
        "dateFormat": "EEEEEE d/M/yy"
      },
      "datePickerDisplayFormat": "EEEEEE d/M/yy",
      "datePickerPreviousMessage": "You can pick up your equipment in the shop on <span>{{ date }}</span> after 15:30. Night skiing excluded.",
      "datePickerPreviousMessageDateFormat": "d/M/yy",
      "formSearchLabel": "Resort, village, country, shop name",
      "formSearchInfo": "One moment please, we are searching for matches...",
      "formSearchResultDescription": "({{region}}, {{province}})",
      "formSearchResultShopNumber": "{{ count }} Shop(s)",
      "formSearchResultShowAll": "Show all {{ count }} results",
      "formSearchResultGroupLocations": "Village",
      "formSearchResultGroupShops": "Shops",
      "formSearchResultGroupRegions": "Region",
      "formSearchResultGroupCountries": "Countries",
      "formSearchButtonLabelDelivery": "From {{price}}",
      "deliverToHotel": "I want the equipment to be delivered to my accommodation - for FREE!",
      "formStartDate": "1st day of rental",
      "formEndDate": "Last day of rental",
      "formNumberOfPeople": "Number of people",
      "formAdultsLabel": "Adults",
      "formPeopleCount": {
        "numberOfPeople": "{{ number_adults }} {{ pluralizeAdult }} {{ number_children }} {{ pluralizeChildren }}",
        "adultNone": "Adults",
        "adultSingle": "Adult",
        "adultMultiple": "Adults",
        "childNone": "Children",
        "childSingle": "Child",
        "childMultiple": "Children"
      },
      "formAdultsLabelInfo": "over 18 years of age at the beginning of the rental",
      "formChildrenLabel": "Children",
      "formChildrenLabelInfo": "under 18 years of age at the begining of the rental",
      "formChildInputLabelInfo": "How old is your child? / How old will your children be at the beginning of the rental?",
      "formChildInputPlaceholder": "how old?",
      "formPromotionCode": "Promotion code",
      "formPromotionCodeNotFound": "This promotion code does not exist.",
      "noResults": "No results found"
    },
    "trustpilot": {
      "dateformat": "d/M/yyyy",
      "score": "TrustScore",
      "reviews": "reviews",
      "reviewsOn": "reviews on"
    },
    "navigation": {
      "skihire": "Ski hire",
      "skischool": "Ski schools",
      "accommodation": "Accommodations",
      "aboutUs": "About us",
      "helpCenter": "Help Center",
      "subnavBooking": "Booking",
      "subnavAdditionalOffers": "Additional Offers",
      "subnavGroupBooking": "Group bookings",
      "subnavTermsAndConditions": "Terms & conditions",
      "subnavBecomePartner": "Become a partner",
      "subnavPrivacyPolicy": "Privacy policy",
      "subnavHelp": "Contact",
      "myAlpinresorts": "My Alpy.com",
      "subnavLogin": "Login",
      "subnavLogout": "Logout",
      "subnavBookingsAndCancellations": "Bookings & Cancellations",
      "subnavPersonalSettings": "Personal Settings",
      "career": "Career",
      "blog": "Blog"
    },
    "geoIp": {
      "chooseACountry": "Please choose a country"
    },
    "topCountries": "Top countries"
  },
  "ALPINSTATIC": {
    "aboutUs": {
      "title": "About us",
      "metaDescription": "This is where you'll find all the information on the team of {{ productName }}.Trust in Europe's biggest network of ski rental outlets and ski schools!"
    },
    "imprint": {
      "title": "Legal information {{ productName }}",
      "metaDescription": "Imprint of {{ productName }}"
    },
    "privacy": {
      "title": "Privacy conditions of {{ productName }}",
      "metaDescription": "Privacy conditions of {{ productName }}"
    },
    "termsAndConditions": {
      "title": "General Terms and Conditions | {{ productName }}",
      "metaDescription": "General conditions of business of {{ productName }}"
    },
    "additionalOffers": {
      "title": "Additional Offers"
    }
  },
  "ROUTES": {
    "CHECKOUT": {
      "PAYMENT": "payment",
      "CHECKOUT": "checkout"
    },
    "CANCELLATION": "cancel-your-booking",
    "SKIHIREENTRY": "ski-rental",
    "COUNTRIES": "countries",
    "PRODUCTS": "products",
    "PRODUCT": {
      "FINISH": "finish"
    },
    "SKIHIRE": {
      "GROUPS": "groups",
      "PRODUCTS": "products",
      "SEARCH": "search"
    },
    "SKISCHOOLENTRY": "ski-school",
    "STATIC": {
      "SWISSPASS": "swisspass",
      "IMPRINT": "imprint",
      "PRIVACYPOLICY": "privacy-policy",
      "TERMSANDCONDITIONS": "terms",
      "HELP": "help",
      "ABOUTUS": "about-us",
      "ADDITIONALOFFERS": "additional-offers",
      "HOWTO": "how-to"
    }
  }
}